var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgErrorCheckIcon = function SvgErrorCheckIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 9C17 13.6944 13.1944 17.5 8.5 17.5C3.80558 17.5 0 13.6944 0 9C0 4.30558 3.80558 0.5 8.5 0.5C13.1944 0.5 17 4.30558 17 9ZM11.7547 12.2549C11.4278 12.5818 10.8979 12.5818 10.571 12.2549L8.49985 10.1837L6.4286 12.255C6.10175 12.5818 5.57182 12.5818 5.24497 12.255C4.91812 11.9281 4.91812 11.3982 5.24497 11.0713L7.31622 9.00008L5.24471 6.92858C4.91786 6.60173 4.91786 6.0718 5.24471 5.74495C5.57157 5.4181 6.10149 5.4181 6.42834 5.74495L8.49985 7.81646L10.5713 5.74501C10.8981 5.41816 11.4281 5.41816 11.7549 5.74501C12.0818 6.07186 12.0818 6.60179 11.7549 6.92864L9.68348 9.00008L11.7547 11.0713C12.0815 11.3981 12.0815 11.9281 11.7547 12.2549Z",
    fill: "#FA0707"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgErrorCheckIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "error-check-icon.7db6051f226e0342db522947b7a40ed6.svg";